import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { WidthTemplates } from '../../utilities/constants/styles.constants.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './quote-block.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class QuoteBlock extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.template = '';
        this.rtlClasses = this.rtl || isRTL() ? 'rtl' : '';
    }
    render() {
        var _a;
        if (this.template === WidthTemplates[1]) {
            // fullWidth
            this.style.maxWidth = 'unset';
        }
        else {
            // default
            this.style.maxWidth = '841px';
        }
        return $ `<div class="quote-block ${this.rtlClasses} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}"><div class="quote-block__quote"><slot name="quote"></slot><div class="quote-block__info"><div class="quote-block__image"><div class="quote-block__swirl"></div><slot name="image"></slot></div><div class="quote-block__text"><slot name="name"></slot><slot name="position"></slot></div></div></div></div>`;
    }
}
QuoteBlock.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: Boolean })
], QuoteBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], QuoteBlock.prototype, "template", void 0);
customElements.define('quote-block', QuoteBlock);

export { QuoteBlock };
